// Sticky navigation state
const vzStickyNav = {
  lastKnownScroll: 0,
  lastScrollPosition: 0,
  scrollTicking: false,
  headerHeight: 20,
  singleHeight: 0,
  footerTop: 0,
  // Cache DOM elements
  elements: {
    body: document.body,
    footerElement: null,
    footerBottom: null,
    contentBeginElement: null
  }
};

/**
 * Cache DOM elements on initialization
 */
function vzCacheElements() {
  vzStickyNav.elements.body = document.body;
  vzStickyNav.elements.footerElement = document.querySelector('footer.footer');
  vzStickyNav.elements.footerBottom = document.getElementById('footer-bottom');
  vzStickyNav.elements.contentBeginElement = document.querySelector('body.single article > section');
}

/**
 * init stickynav parameters, in this case header height
 */
function stickyNavInit() {
  // Re-cache elements in case DOM changed
  vzCacheElements();

  const { contentBeginElement, footerElement, footerBottom } = vzStickyNav.elements;

  if (contentBeginElement) {
    vzStickyNav.singleHeight = contentBeginElement.offsetTop + contentBeginElement.offsetHeight;
  }

  if (footerElement && footerBottom) {
    const windowHeight = window.innerHeight;
    if (windowHeight >= footerBottom.offsetTop) {
      footerElement.classList.add('sticky-bottom-attach');
    }
  }
}

/**
 * update footer values on scroll
 */
function stickyNavFooter() {
  const { footerBottom } = vzStickyNav.elements;
  if (!footerBottom) return;

  const windowHeight = window.innerHeight;
  vzStickyNav.footerTop = footerBottom.offsetTop - windowHeight;
}

/**
 * update sticky nav
 * @param {Number} scrollPos
 */
function stickyNavUpdate(scrollPos) {
  const scrollDelta = scrollPos - vzStickyNav.lastScrollPosition;
  vzStickyNav.lastScrollPosition = scrollPos;

  stickyNavFooter();

  const { body, footerElement } = vzStickyNav.elements;
  const { headerHeight, singleHeight, footerTop } = vzStickyNav;

  // Update scroll direction classes
  if (scrollPos < headerHeight) {
    // default header view
    body.classList.remove('vz-scroll-down', 'vz-scroll-up');
  } else if (scrollDelta >= 0) {
    // shrink top, show bottom
    body.classList.add('vz-scroll-down');
    body.classList.remove('vz-scroll-up');
  } else {
    // show top, hide bottom
    body.classList.remove('vz-scroll-down');
    body.classList.add('vz-scroll-up');
  }

  // Update footer sticky state
  if (footerElement) {
    if (scrollPos >= footerTop) {
      footerElement.classList.add('sticky-bottom-attach');
    } else {
      footerElement.classList.remove('sticky-bottom-attach');
    }
  }

  // Update title switch for single posts
  if (singleHeight) {
    if (scrollPos >= singleHeight) {
      body.classList.add('vz-title-switch');
    } else {
      body.classList.remove('vz-title-switch');
    }
  }
}

/**
 * Scroll event handler with requestAnimationFrame throttling
 */
function handleScroll() {
  vzStickyNav.lastKnownScroll = window.pageYOffset || document.documentElement.scrollTop;

  if (!vzStickyNav.scrollTicking) {
    window.requestAnimationFrame(() => {
      stickyNavUpdate(vzStickyNav.lastKnownScroll);
      vzStickyNav.scrollTicking = false;
    });

    vzStickyNav.scrollTicking = true;
  }
}

function stickyNavBind() {
  if (vzStickyNav.isBound) {
    return;
  }

  vzStickyNav.isBound = true;
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', stickyNavInit, { passive: true });
}
